import ChartTypeToggle from "../components/ChartTypeToggle";
import { CHART_TYPE_STORAGE_KEY } from "./constants";

const DoraLeadTimeChangesHeaderActions = () => (
  <ChartTypeToggle storageKey={CHART_TYPE_STORAGE_KEY} />
);

export default DoraLeadTimeChangesHeaderActions;
